var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRejectedOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.469,
    height: 7.469,
    viewBox: "0 0 7.469 7.469",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8216",
    "data-name": "Group 8216",
    transform: "translate(9748.701 -9977.231)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1321",
    "data-name": "Line 1321",
    y2: 7.561,
    transform: "translate(-9742.294 9978.293) rotate(45)",
    fill: "none",
    stroke: "#d3221e",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1322",
    "data-name": "Line 1322",
    y2: 7.561,
    transform: "translate(-9742.293 9983.639) rotate(135)",
    fill: "none",
    stroke: "#d3221e",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectedOrder);
export default __webpack_public_path__ + "static/media/Rejected Order.546b0352a14d98fbfe3b714ff84b9a2c.svg";
export { ForwardRef as ReactComponent };